export const WASH_TARGETS = {
  ADDED_WASHES: 'addedWashes',
  ADD_WASH: 'addWash',
  CURRENT_WASH: 'currentWash'
};

export const WASH_DEFAULT_STATE = {
  [WASH_TARGETS.ADDED_WASHES]: [],
  [WASH_TARGETS.ADD_WASH]: null,
  [WASH_TARGETS.CURRENT_WASH]: {}
};
